// 后端api地址
// let web_url= 'http://10.0.1.2:48888';
let web_url= 'https://liusha.shanhu188.com';
// let web_url = 'https://admin.cjaozi.cn'

// 线上登录api地址
// let sx_web_url = 'http://10.0.1.2:48888'
let sx_web_url= 'https://liusha.shanhu188.com';
// let sx_web_url = 'https://admin.cjaozi.cn'

let system_web_url = 'http://120.24.62.87:30881'
// let web_url= 'http://120.24.62.87:30881';

//工单接口
let gd_web_url = 'http://120.24.62.87:30882'
// web_url='http://127.0.0.1:8887';

//socket地址
let socket_url = 'wss://fiot.zjwhwl.com:9087/web'
// socket_url='ws://localhost:9087/web';
export { web_url, socket_url, gd_web_url, system_web_url, sx_web_url }



// WEBPACK FOOTER //
// ./src/api/baseUrl.js